<template lang="html">
	<div class="patrimonial-form">
		<form class="form-ui landscape-patrimonial-ui" novalidate>
			<div class="ctn-toggle row">
				<div class="label">
					Avez vous des enfants ou petits enfants ?
				</div>
				<custom-toggle :value="isChilds" @change="changeChilds($event)"/>
			</div>
			<div class="ctn-add-children row" v-if="isChilds">
				<custom-select :solo="true" :items="typeChild" :selected="typeToAdd" @change="typeToAdd=$event"/>
				<div class="btn-add" @click="addChild">
					<span class="icon-form-plus"></span>
				</div>
			</div>
			<div class="ctn-childrens" v-if="isChilds">
				<div class="ctn-children" v-for="(child, key) in listOfChild" v-bind:key="key">
					<div class="type-children row">
						{{ child.type }} {{ key + 1 }} <div class="link" @click="removeChild(key)">supprimer</div>
					</div>
					<div class="form-elem-container row">
						<div class="ctn-input ctn-label" :class="{error: errors.has('prénom' + (key + 1))}">
							<label for="prénom">Prénom</label>
							<input v-validate="'required'" type="text" :name="'prénom' + (key + 1)" v-model="child.firstname" :key="'childfn-' + key">
						</div>
						<div class="error-message">{{ errors.first('prénom' + (key + 1))}}</div>
					</div>
					<div class="form-elem-container row">
						<div class="ctn-input ctn-label" :class="{error: errors.has('nom' + (key + 1))}">
							<label for="nom">Nom</label>
							<input v-validate="'required'" type="text" :name="'nom' + (key + 1)" v-model="child.lastname" :key="'childln-' + key">
						</div>
						<div class="error-message">{{ errors.first('nom' + (key + 1))}}</div>
					</div>
					<div class="form-elem-container row">
						<div class="ctn-input ctn-label" :class="{error: errors.has('date de naissance' + (key + 1))}">
							<label for="date de naissance">Date de naissance</label>
							<input v-validate="'required'" type="date" :name="'date de naissance' + (key + 1)" v-model="child.dateOfBirth" :key="'childbd-' + key">
						</div>
						<div class="error-message">{{ errors.first('date de naissance' + (key + 1))}}</div>
					</div>
				</div>
			</div>
		</form>
  </div>
</template>

<script>
import CustomToggle from '@/common/components/Form/CustomToggle'
import CustomSelect from '@/common/components/Form/CustomSelect'
import { mapGetters } from 'vuex'

class Child {
	constructor () {
		this.firstname = null
		this.lastname = null
		this.dateOfBirth = null
		this.type = null
	}
}

export default {
	name: 'YourHome',
	components: {
		CustomToggle,
		CustomSelect
	},
	data () {
		return {
			typeChild: [
				'Enfant',
				'Petit-enfant'
			],
			typeToAdd: null,
			listOfChild: [],
			isChilds: false
		}
	},
	mounted () {
		this.initializeChildren()
	},
	methods: {
		initializeChildren () {
			this.typeToAdd = this.typeChild[0]
			this.listOfChild = (this.estate.childs.length > 0) ? this.$iRobot.arrayClone(this.estate.childs) : []
			if (this.listOfChild.length > 0) {
				this.isChilds = true
				this.listOfChild.forEach((child) => {
					child.dateOfBirth = child.dateOfBirth.toString().split('/').reverse().join('-')
				})
			}
		},
		validate () {
			return this.$validator.validate()
		},
		addChild () {
			let foo = new Child()
			foo.type = this.typeToAdd
			this.listOfChild = this.listOfChild.concat([foo])
		},
		changeChilds (value) {
			this.isChilds = value
			if (!value) {
				this.listOfChild = []
			}
		},
		removeChild (key) {
			this.listOfChild.splice(key, 1)
		},
		refreshDataSaved () {
			setTimeout(() => {
				this.initializeChildren()
			}, 10000)
		},
		save () {
			return new Promise((resolve, reject) => {
				this.validate().then((validation) => {
					if (validation) {
						this.$store.dispatch('storePatrimonial', {
							name: 'YOUR_HOME',
							data: this.listOfChild,
							fromStart: false
						}).then(() => {
							resolve()
							this.refreshDataSaved()
						})
					}
				})
			})
		}
	},
	beforeDestroy () {
		this.save()
	},
	computed: {
		...mapGetters({
			estate: 'estate'
		})
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// YourHome.vue?b8034bf0